import { render, staticRenderFns } from "./charmTargetProcessDetail.vue?vue&type=template&id=64a3293e"
import script from "./charmTargetProcessDetail.vue?vue&type=script&lang=js"
export * from "./charmTargetProcessDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a3293e')) {
      api.createRecord('64a3293e', component.options)
    } else {
      api.reload('64a3293e', component.options)
    }
    module.hot.accept("./charmTargetProcessDetail.vue?vue&type=template&id=64a3293e", function () {
      api.rerender('64a3293e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/plan/charmTargetProcessDetail.vue"
export default component.exports